// image
import { getPeriodKeyFromFileRowIdAndCustomDate } from '../../../../../pages/MediaOrderSummary/MediaOrderSummaryContent/RequestedFilesSection/helpers'

export const FILE_NAME = 'name'
export const FILE_URL = 'file_url'
// file upload
export const FILE_UPLOAD_OPTION = 'file_upload_option'
export const FILE_UPLOAD = 'file_upload'
// existing file selection
export const FILE_SELECT_EXISTING = 'file_select_existing'
export const FILE_SELECTED_NAME = 'selected_file_name'
export const FILE_SELECTED_URL = 'selected_file_url'
export const SELECTED_PERIODS = 'booked_medias'
export const OVERRIDE_VALIDATION = 'override_validation'
export const CUSTOM_BOOKING_DATE = 'custom_booking_date'

export const PERIOD_IS_SELECTED = 'selected'

export const initialImageFileValues = {
  [FILE_NAME]: '',
  [FILE_URL]: ''
}

export const getInitialValues = ({
  selectedFileId,
  selectedBookedMediaId,
  allAvailableRequestedFiles,
  selectedCustomDate
}) => {
  const selectedPeriodKey = getPeriodKeyFromFileRowIdAndCustomDate({
    fileId: selectedFileId,
    bookedMediaId: selectedBookedMediaId,
    customDate: selectedCustomDate
  })

  // each available booked media has its own period, so we need to set initially all available booked media periods
  const bookedMediaPeriods = {}
  allAvailableRequestedFiles.forEach(file => {
    const { requested_file } = file
    const fileId = requested_file.id
    const bookedMediaId = requested_file.booked_media_id
    const customDate = requested_file.custom_date && requested_file.date_start

    const periodKey = getPeriodKeyFromFileRowIdAndCustomDate({
      fileId,
      bookedMediaId,
      customDate
    })

    bookedMediaPeriods[periodKey] = {
      data: file,
      [PERIOD_IS_SELECTED]: periodKey === selectedPeriodKey
    }
  })

  return {
    ...initialImageFileValues,
    [FILE_UPLOAD_OPTION]: FILE_UPLOAD,
    [FILE_SELECTED_NAME]: '',
    [FILE_SELECTED_URL]: '',
    // user can set the uploaded file to other products booked media periods
    [SELECTED_PERIODS]: bookedMediaPeriods,
    [OVERRIDE_VALIDATION]: false
  }
}
